import { render, staticRenderFns } from "./TeamChat.vue?vue&type=template&id=5b099973&scoped=true"
import script from "./TeamChat.vue?vue&type=script&lang=js"
export * from "./TeamChat.vue?vue&type=script&lang=js"
import style0 from "./TeamChat.vue?vue&type=style&index=0&id=5b099973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b099973",
  null
  
)

export default component.exports